module.exports = __webpack_public_path__ + "img/icon-herbal.b2f3b0d2.svg";